import { Leaf } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-primary text-primary-foreground"
    >
      <div className="container-wide py-14 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center">
            <img src="/logo.png" alt="Green Earth Energy Solutions" className="h-12 w-auto object-contain bg-white rounded-md p-1.5" />
          </div>
          <p className="mt-4 text-sm text-primary-foreground/80 max-w-md leading-relaxed">
            Creating a sustainable world for the future. Energy Transition,
            Sustainability & De‑Carbonisation Solution Provider with 25+ years of
            energy industry experience.
          </p>
        </div>

        <div className="lg:col-span-3">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-primary-foreground/70">
            Sectors
          </p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a className="hover:text-accent" href="#sectors">Energy</a></li>
            <li><a className="hover:text-accent" href="#sectors">Energy Transition</a></li>
            <li><a className="hover:text-accent" href="#sectors">Green Energy</a></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-primary-foreground/70">
            Get in Touch
          </p>
          <ul className="mt-4 space-y-2 text-sm text-primary-foreground/90">
            <li>London, UK • Abu Dhabi, UAE</li>
            <li>
              <a className="hover:text-accent" href="mailto:sales@greenearthuk.co.uk">
                sales@greenearthuk.co.uk
              </a>
            </li>
            <li>
              <a className="hover:text-accent" href="tel:+442035040957">+44 20 3504 0957</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/15">
        <div className="container-wide py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-primary-foreground/70">
          <div className="flex flex-col gap-1">
            <p>© {new Date().getFullYear()} Green Earth Energy Solutions. All rights reserved.</p>
            <p>
              Designed & developed by{" "}
              <a
                href="https://4csolutions.in"
                target="_blank"
                rel="noreferrer"
                className="hover:text-accent transition-colors"
              >
                4C Solutions
              </a>
            </p>
          </div>
          <p>Net Carbon Zero • One‑Stop Solutions for Energy Transition</p>
        </div>
      </div>
    </footer>
  );
}
